
// ==============================================
//    DYWANAH GLOBAL START
// ==============================================
// ==========================
// DYWANAH AT THE TOP OF THE theme.js FILE - SCROLL LOCK UTILITY START
// Used to prevent background scroll on mobile FOR smarttabs popups
// ==========================
let scrollY = 0;

function lockBodyScroll() {
  scrollY = window.scrollY;
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
}

function unlockBodyScroll() {
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  window.scrollTo(0, scrollY);
}
// ==========================
// DYWANAH SCROLL LOCK UTILITY END
// ==========================

const productInfo = document.querySelector('.product-info');
// ==============================================
//    DYWANAH GLOBAL END
// ==============================================


// =======================================================================================================================================
//    Custom code to change product card "color name text" to the selected swatch name - adjusted to work with Sorting & Filtering - START
// =======================================================================================================================================

// Update swatch text when a swatch is clicked
function updateSwatchText(event) {
    let swatch = event.target.closest(".swatch-view-item");
    if (!swatch) return;

    let productCard = swatch.closest("product-card");
    if (!productCard) return;

    let colorText = productCard.querySelector("#current-product-color");
    if (!colorText) return;

    let newColor = swatch.getAttribute("aria-label") ||
                   swatch.getAttribute("orig-value") ||
                   swatch.dataset.value;

    if (newColor) {
        // Remove any "- Sold Out" suffix
        newColor = newColor.replace(/\s*-\s*Sold\s*Out\s*/gi, '');
        colorText.textContent = newColor;
    }
}

// Set up all event listeners (delegation)
function swatchClickHandler(event) {
    let swatch = event.target.closest(".swatch-view-item");
    if (swatch) {
        updateSwatchText({ target: swatch });
    }
}

function setupSwatchListeners() {
    // Remove any previous listener to avoid duplicates
    document.body.removeEventListener("click", swatchClickHandler, true);
    document.body.addEventListener("click", swatchClickHandler, true);
}
// =======================================================================================================================================
//    Custom code to change product card "color name text" to the selected swatch name - adjusted to work with Sorting & Filtering - END
// =======================================================================================================================================


// ========================================================================================================================
// DYWANAH Badge System - Complete Solution
// - Badge System for All DYWANAH custom Badging sytem that include (NEW - On Sale - SOld Out ... etc) badges
// - Directly uses the swatch-generated attribute at the product-card level to determine the current color variant
// - Ensures SOLD OUT badge properly displays and takes precedence when switching to a sold-out variant
// - Correctly shows/hides ON SALE badge based on the selected variant's sale status
// - Works for both initial load and when switching between colors      adjusted to work with Sorting & Filtering -   START 
// ========================================================================================================================

// Helper function to check if a card's current variant is sold out
function checkCardSoldOutStatus(card) {
  // First check if the card has a sold-out class
  if (card.classList.contains('soldout') || 
      card.classList.contains('sold-out') || 
      card.classList.contains('swatch-variant-soldout') || 
      card.hasAttribute('swatch-variant-soldout')) {
    return true;
  }
  
  // Check if sold-out badge is visible
  const soldOutBadge = card.querySelector('[data-badge-type="soldout"]');
  if (soldOutBadge && window.getComputedStyle(soldOutBadge).display !== 'none') {
    return true;
  }
  
  return false;
}

function setupBadgeBehavior() {
  // Process all product cards
  document.querySelectorAll('.product-card').forEach(card => {
    // Get the badges on this card
    const soldOutBadge = card.querySelector('[data-badge-type="soldout"]');
    const saleBadge = card.querySelector('[data-badge-type="sale"]');
    const newBadge = card.querySelector('[data-badge-type="new"]');
    const priceList = card.querySelector('.price-list');
    
    // Skip if no badges found
    if (!soldOutBadge && !saleBadge && !newBadge) return;
    
    // Track which variant is displayed
    updateBadgeStates(card);

    // Watch for attribute changes on the product card
    const observer = new MutationObserver(() => {
      updateBadgeStates(card);
      // Also update price list visibility when attributes change
      const currentSoldOutState = checkProductSoldOutStatus(card);
      if (priceList) {
        priceList.style.display = currentSoldOutState ? 'none' : '';
      }
    });
    
    // Observe relevant attribute changes
    observer.observe(card, { 
      attributes: true, 
      attributeFilter: ['swatch-generated', 'class', 'swatch-variant-soldout'] 
    });
    
    // Also handle clicks on swatches for backup
    card.addEventListener('click', event => {
      const swatch = event.target.closest('.swatch-view-item, .color-swatch, .swatch-element');
      if (swatch) {
        // Give it a moment for attributes to update
        setTimeout(() => {
          updateBadgeStates(card);
          const currentSoldOutState = checkProductSoldOutStatus(card);
          if (priceList) {
            priceList.style.display = currentSoldOutState ? 'none' : '';
          }
        }, 150);
        
        // Check again after a bit longer
        setTimeout(() => {
          updateBadgeStates(card);
          const currentSoldOutState = checkProductSoldOutStatus(card);
          if (priceList) {
            priceList.style.display = currentSoldOutState ? 'none' : '';
          }
        }, 1500);
      }
    });
  });
}

// Function to check if a product is sold out using the same comprehensive logic as updateBadgeStates
function checkProductSoldOutStatus(card) {
  // Direct class checks
  let isSoldOut = card.classList.contains('swatch-variant-soldout') || 
                 card.hasAttribute('swatch-variant-soldout') ||
                 card.classList.contains('soldout') || 
                 card.classList.contains('sold-out');
  
  if (isSoldOut) return true;
  
  // Get the current color variant from swatch-generated
  const swatchGenerated = card.getAttribute('swatch-generated') || '';
  const handle = card.getAttribute('handle') || '';
  
  // Check product data
  if (swatchGenerated) {
    const productData = card.querySelector('.dywanah-product-data');
    if (productData) {
      try {
        const data = JSON.parse(productData.textContent);
        
        // Get the color from swatch-generated
        const colorParts = swatchGenerated.split('-');
        const color = colorParts[colorParts.length - 1]; // Last part is color
        
        // Find if any variant with this color is unavailable
        for (const variant of data.variants) {
          if (!variant.available) {
            // Check if this unavailable variant matches our current color
            if (swatchGenerated.includes(handle) && 
                swatchGenerated.includes(color)) {
              return true;
            }
          }
        }
      } catch (e) {
        // Silent error handling
      }
    }
  }
  
  // Check for SOLD OUT button
  const soldOutButton = card.querySelector('.sold-out-button');
  if (soldOutButton) {
    return true;
  }
  
  // Check if sold-out badge is visible
  const soldOutBadge = card.querySelector('[data-badge-type="soldout"]');
  if (soldOutBadge && window.getComputedStyle(soldOutBadge).display !== 'none') {
    return true;
  }
  
  return false;
}

function updateBadgeStates(card) {
  // Get badge elements
  const soldOutBadge = card.querySelector('[data-badge-type="soldout"]');
  const saleBadge = card.querySelector('[data-badge-type="sale"]');
  const newBadge = card.querySelector('[data-badge-type="new"]');
  
  // Skip if no badges
  if (!soldOutBadge && !saleBadge && !newBadge) return;
  
  // Get the current color variant from swatch-generated
  const swatchGenerated = card.getAttribute('swatch-generated') || '';
  const handle = card.getAttribute('handle') || '';
  
  // Determine if the variant is sold out - start with direct class checks
  let isSoldOut = card.classList.contains('swatch-variant-soldout') || 
                  card.hasAttribute('swatch-variant-soldout');
  
  // Look for soldout class at card level
  if (card.classList.contains('soldout') || card.classList.contains('sold-out')) {
    isSoldOut = true;
  }
  
  // If direct indicators don't show sold out, check product data
  if (!isSoldOut && swatchGenerated) {
    const productData = card.querySelector('.dywanah-product-data');
    if (productData) {
      try {
        const data = JSON.parse(productData.textContent);
        
        // Get the color from swatch-generated
        const colorParts = swatchGenerated.split('-');
        const color = colorParts[colorParts.length - 1]; // Last part is color
        
        // Find if any variant with this color is unavailable
        for (const variant of data.variants) {
          if (!variant.available) {
            // Check if this unavailable variant matches our current color
            if (swatchGenerated.includes(handle) && 
                swatchGenerated.includes(color)) {
              isSoldOut = true;
              break;
            }
          }
        }
      } catch (e) {
        // Silent error handling
      }
    }
  }
  
  // Check for SOLD OUT direct from class (another indicator)
  const soldOutClass = card.querySelector('.sold-out-button') !== null;
  if (soldOutClass) {
    isSoldOut = true;
  }
  
  // Check for ON SALE state
  const compareAtPrice = card.querySelector('compare-at-price');
  const salePrice = card.querySelector('sale-price');
  const isOnSale = compareAtPrice && salePrice && 
                  window.getComputedStyle(compareAtPrice).display !== 'none' &&
                  compareAtPrice.textContent.trim() !== '';
  
  // Update badge visibility
  if (isSoldOut) {
    // Sold out - show SOLD OUT badge, hide others
    if (soldOutBadge) soldOutBadge.style.display = 'block';
    if (saleBadge) saleBadge.style.display = 'none';
    if (newBadge) newBadge.style.display = 'none';
  } else {
    // Not sold out
    if (soldOutBadge) soldOutBadge.style.display = 'none';
    
    // Handle SALE badge
    if (saleBadge) {
      saleBadge.style.display = isOnSale ? 'block' : 'none';
      
      // Update discount percentage if needed
      if (isOnSale) {
        try {
          const compareValue = parseFloat(compareAtPrice.textContent.replace(/[^0-9.]/g, ''));
          const saleValue = parseFloat(salePrice.textContent.replace(/[^0-9.]/g, ''));
          
          if (compareValue > saleValue) {
            const discountPercentage = Math.round(((compareValue - saleValue) / compareValue) * 100);
            const percentSpan = saleBadge.querySelector('span');
            if (percentSpan) {
              percentSpan.textContent = `${discountPercentage}% OFF`;
            }
          }
        } catch (e) {
          // Silent error handling
        }
      }
    }
    
    // Show NEW badge if it exists
    if (newBadge) {
      newBadge.style.display = 'block';
    }
  }
}

// Remove any conflicting badges from other systems
function removeInjectedBadges() {
  document.querySelectorAll('.badge-list').forEach(el => el.remove());
}

// Clean up injected badges when new ones are added
const badgeObserver = new MutationObserver(mutations => {
  for (const mutation of mutations) {
    if (mutation.addedNodes.length) {
      for (const node of mutation.addedNodes) {
        if (node.classList && node.classList.contains('badge-list')) {
          node.remove();
        }
      }
    }
  }
});

// Start watching for injected badges
badgeObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Clean badges on initial load
setTimeout(removeInjectedBadges, 500);
// =======================================================================================================================
// DYWANAH Badge System - Complete Solution
// - Badge System for All DYWANAH custom Badging sytem that include (NEW - On Sale - SOld Out ... etc) badges
// - Directly uses the swatch-generated attribute at the product-card level to determine the current color variant
// - Ensures SOLD OUT badge properly displays and takes precedence when switching to a sold-out variant
// - Correctly shows/hides ON SALE badge based on the selected variant's sale status
// - Works for both initial load and when switching between colors      adjusted to work with Sorting & Filtering -   END 
// =======================================================================================================================


// ===========================================================================================================================
// DYWANAH Script to help visually differentiate discounted product prices on product cards.
// When a discount exists, the compare-at-price element is shown; otherwise, it is removed.
// This supports styling the price element in the product card with a specific colour based on discount presence.   
// Handles Saudi Ryal Currency Symbol On Product Cards - Because SwatchKing Javascript Injection Impacts it by default - START
// ===========================================================================================================================


function setupPriceObservers() {
  document.querySelectorAll('.product-card').forEach((productCard) => {
    const priceList = productCard.querySelector('.price-list');
    if (!priceList) return;

    // Replace SAR with our custom symbol
    function replaceCurrencySymbols(node) {
      const targetSpans = node.querySelectorAll('sale-price, compare-at-price, .price-list span');
      targetSpans.forEach((span) => {
        if (span.textContent.includes('SAR')) {
          span.innerHTML = span.innerHTML.replace(
            'SAR',
            '<span class="icon-saudi_riyal" aria-hidden="true"></span>'
          );
        }
      });
    }

    // Wrap raw price amounts in <span class="price-amount">
    function wrapSalePriceAmounts(node) {
      const salePriceElements = node.querySelectorAll('sale-price');
      salePriceElements.forEach((el) => {
        el.childNodes.forEach((child) => {
          if (child.nodeType === Node.TEXT_NODE && child.nodeValue.trim().length > 0) {
            // Remove the raw text
            const textValue = child.nodeValue.trim();
            el.removeChild(child);
    
            // Create the span and append it at the end
            const span = document.createElement('span');
            span.className = 'price-amount';
            span.textContent = textValue;
            el.appendChild(span);
          }
        });
      });
    }

    // Observe dynamic changes to the price list
    function observePriceList(node) {
      const priceObserver = new MutationObserver(() => {
        const compareAtPrice = node.querySelector('compare-at-price');
        if (compareAtPrice && compareAtPrice.style.display === 'none') {
          compareAtPrice.remove();
        }

        // Apply SAR replacement and wrapping
        replaceCurrencySymbols(node);
        wrapSalePriceAmounts(node);
      });

      priceObserver.observe(node, { childList: true, subtree: true });
    }

    // Initial run
    observePriceList(priceList);
    replaceCurrencySymbols(priceList);
    wrapSalePriceAmounts(priceList);

    // Watch for variant (swatch) changes
    const cardObserver = new MutationObserver(() => {
      const updatedPriceList = productCard.querySelector('.price-list');
      if (updatedPriceList && updatedPriceList.innerHTML !== priceList.innerHTML) {
        observePriceList(updatedPriceList);
        replaceCurrencySymbols(updatedPriceList);
        wrapSalePriceAmounts(updatedPriceList);
      }
    });

    cardObserver.observe(productCard, { childList: true, subtree: true });
  });
}
// ===========================================================================================================================
// DYWANAH Script to help visually differentiate discounted product prices on product cards.
// When a discount exists, the compare-at-price element is shown; otherwise, it is removed.
// This supports styling the price element in the product card with a specific colour based on discount presence.   
// Handles Saudi Ryal Currency Symbol On Product Cards - Because SwatchKing Javascript Injection Impacts it by default - END
// ===========================================================================================================================

// ========================================================================================================================
// DYWANAH Unified observer for main element to handle sorting/filtering AJAX updates for all features
// ========================================================================================================================

function observeProductList() {
    // Use the most specific container for your product grid/list in our case unfortunatly it is <main> which a broadf scope
    let productList = document.querySelector('main#main'); // <-- UPDATE THIS SELECTOR as needed
    if (!productList) return;

    if (window._productListObserver) {
        window._productListObserver.disconnect();
    }

    // Debounce to avoid rapid repeated calls
    let debounceTimeout;
    const observer = new MutationObserver(() => {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => {
            setupSwatchListeners();
            setupBadgeBehavior();
            removeInjectedBadges();
            setupPriceObservers();
            // Re-attach observer in case the productList container was replaced
            observeProductList();
        }, 300); // Adjust delay as needed
    });
    observer.observe(productList, { childList: true, subtree: true });
    window._productListObserver = observer;
}
// ========================================================================================================================
// DYWANAH SINGLE DOMContentLoaded block for all initializations
// ========================================================================================================================

document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        setupSwatchListeners();
        setupBadgeBehavior();
        removeInjectedBadges();
        setupPriceObservers();
        observeProductList(); // <-- Call the correct observer here
    }, 1500); // Adjust delay as needed
});

// ========================================================================================================================
// DYWANAH SINGLE DOMContentLoaded block for all initializations
// ========================================================================================================================






//--------------- Custom code to Remove Default Product Card Badges Used by Swatch King App-----------------//
function removeInjectedBadges() {
  document.querySelectorAll('.badge-list').forEach(el => el.remove());
}

const observer = new MutationObserver(() => {
  removeInjectedBadges();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

// Clean on initial load
removeInjectedBadges();

//----- Custom code to expand gallery list images on Desktop.------//

const expandBtn = document.querySelector('.dywanah-expand-gallery-btn');
const imageList = document.querySelector('.product-gallery__image-list');
const fadeBottom = document.querySelector('.dywanah-gallery-fade-bottom');

if (expandBtn && imageList && fadeBottom) {
  expandBtn.addEventListener('click', () => {
    imageList.classList.add('dywanah-gallery-expand');
    fadeBottom.style.display = 'none';
  });
}

// ================== Custom code For MY Floating "ADD To Cart" - NOT StickyCart App - START ================== //

document.addEventListener("DOMContentLoaded", function () {
  if (!window.location.pathname.includes("/products/")) return;

  const floating = document.getElementById("DYWANAH-floating-cart-button");
  const anchor = document.getElementById("DYWANAH-product-form-anchor");

  if (!floating || !anchor) return;

  const observer = new IntersectionObserver(([entry]) => {
    const top = entry.boundingClientRect.top;

    if (entry.isIntersecting) {
      floating.classList.add("hide");
    } else {
      floating.classList.remove("hide");
    }

    if (top > 0) {
      floating.classList.remove("lower");
    } else {
      floating.classList.add("lower");
    }
  });

  observer.observe(anchor);

  // Optional: Adjust on scroll start
  window.addEventListener("scroll", () => {
    const scrollPercent = window.scrollY / document.body.scrollHeight;
    if (scrollPercent > 0.02) {
      floating.style.bottom = "0px";
    } else {
      floating.style.bottom = "40px";
    }
  });
});
// ================== Custom code For MY Floating "ADD To Cart" - NOT StickyCart App - END ================== //




// ================== Custom code to PRODUCT SMARTTABS POPUP ================== //

// Move tab popup wrapper to <body> to appear above the page navigation header on desktop

if (window.location.pathname.includes('/products/')) {
  document.addEventListener("DOMContentLoaded", function () {
      const popupWrapper = document.getElementById("tab-popup-backdrop");
      if (popupWrapper) {
        document.body.appendChild(popupWrapper);
      }
    });
    
    // Utility to extract only the pure text node (ignores icons, SVG, etc.)
    function getTabLabel(tabElement) {
      for (let node of tabElement.childNodes) {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== "") {
          return node.textContent.trim();
        }
      }
      return 'تفاصيل'; // Fallback if nothing is found
    }
    
    // Delegated click listener to support dynamic tabs
    document.addEventListener('click', function (e) {
      const tab = e.target.closest('.smart-tabs-navigation-li');
      const StickyCart = document.querySelector('.giraffly_phoneButtonPreview');
      if (!tab) return;
    
      const tabId = tab.getAttribute('data-tab-link-id');
      const contentId = `smart-tabs-content-${tabId}`;
      const tabLabel = getTabLabel(tab); // Use clean label only
    
      setTimeout(() => {
        const content = document.querySelector(`#${contentId}`);
        if (content) {
          const popup = document.getElementById('tab-popup'); // Now inside moved wrapper
          const popupWrapper = document.getElementById("tab-popup-backdrop");
          const popupBody = popup.querySelector('.tab-popup-body');
          const popupTitle = document.getElementById('tab-popup-title');
    
          popupBody.innerHTML = content.innerHTML;
          popupTitle.textContent = tabLabel;
    
          popup.classList.add('open');
          popupWrapper.classList.add('open');
          lockBodyScroll();
        } 
      }, 100);
      StickyCart.style.zIndex = '0';
      if (productInfo) {
      productInfo.style.position = 'relative'; // or 'static'
      productInfo.classList.add('top');
      }
    });
    
    // Close popup when clicking on the close button
    document.querySelector('.tab-popup-close')?.addEventListener('click', () => {
      const StickyCart = document.querySelector('.giraffly_phoneButtonPreview');
      document.getElementById('tab-popup')?.classList.remove('open');
      document.getElementById('tab-popup-backdrop')?.classList.remove('open');
      unlockBodyScroll();
      StickyCart.style.zIndex = '10';
      if (productInfo) {
      productInfo.style.position = 'sticky';
      productInfo.classList.remove('top');
      }
    });
}
  // Close popup when clicking outside (on backdrop)
  document.getElementById('tab-popup-backdrop')?.addEventListener('click', function (e) {
    const popup = document.getElementById('tab-popup');
    const StickyCart = document.querySelector('.giraffly_phoneButtonPreview');
    if (!popup.contains(e.target)) {
      popup.classList.remove('open');
      this.classList.remove('open');
      unlockBodyScroll();
      StickyCart.style.zIndex = '10';
      if (productInfo) {
      productInfo.style.position = 'sticky';
      productInfo.classList.remove('top');
     }
    }
  });



// ====================================================================================
// DYWANAH Custom Code To enable QuickBuy icon on product card normal functionality
// to move and and product to cart page (App setting) when the user clicks on it.
// As normal app (Sticky AddToCart) behavior with any variant enabled 
// on the product (Color in our case) is Messy as we use product-groups with SwatchKing.
// ====================================================================================


document.addEventListener('click', function(e) {
  var quickBuyIcon = e.target.closest('.giraffly_Quickbuy_Round');
  if (quickBuyIcon) {
    var productCard = quickBuyIcon.closest('.product-card');
    if (!productCard) return;

    var attempts = 0;
    var maxAttempts = 20; // Try for up to 2 seconds (20 x 100ms)
    var poll = setInterval(function() {
      var dropdown = productCard.querySelector('.giraffly_Quickbuy-dropdown');
      if (dropdown) {
        var firstVariant = dropdown.querySelector('.giraffly_Select_Li:not([data-sold_out="1"])');
        if (firstVariant) {
          firstVariant.click();
          clearInterval(poll);
        }
      }
      attempts++;
      if (attempts > maxAttempts) {
        clearInterval(poll);
      }
    }, 50);
  }
}, true);



// ================== Custom code to Inject Custom Styling For PhotoSwipe Zoom Function ================== //

document.addEventListener('DOMContentLoaded', function() {
  let pswpInterval = setInterval(function() {
    if (window.pswp && window.pswp.isOpen) {
      // --- Custom Bottom Bar ---
      if (!window.pswp.element.querySelector('.pswp__custom-bottom-bar')) {
        var pswp = window.pswp;
        var bar = document.createElement('div');
        bar.className = 'pswp__custom-bottom-bar';
        bar.innerHTML = `
          <button type="button" class="pswp__custom-arrow pswp__custom-arrow--prev" aria-label="Previous">
            <svg aria-hidden="true" focusable="false" fill="none" width="12" height="12" stroke-width="3"; class="icon icon--direction-aware" viewBox="0 0 16 18">
              <path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square"></path>
            </svg>
          </button>
          <span class="pswp__custom-counter"></span>
          <button type="button" class="pswp__custom-arrow pswp__custom-arrow--next" aria-label="Next">
            <svg aria-hidden="true" focusable="false" fill="none" width="12" height="12" stroke-width="3"; class="icon icon--direction-aware" viewBox="0 0 16 18">
              <path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"></path>
            </svg>
          </button>
        `;
        pswp.element.appendChild(bar);

        // Wire up the custom buttons
        bar.querySelector('.pswp__custom-arrow--prev').onclick = function() { pswp.prev(); };
        bar.querySelector('.pswp__custom-arrow--next').onclick = function() { pswp.next(); };

        // Update the counter
        var updateCounter = function() {
          var counter = bar.querySelector('.pswp__custom-counter');
          if (counter) {
            counter.textContent = (pswp.currIndex + 1) + ' / ' + pswp.getNumItems();
          }
        };
        pswp.on('change', updateCounter);
        updateCounter();

        // Hide default arrows and counter
        var defaultArrows = pswp.element.querySelectorAll('.pswp__button--arrow--prev, .pswp__button--arrow--next, .pswp__counter');
        defaultArrows.forEach(function(el) { el.style.display = 'none'; });
      }

      // --- Custom Close Button ---
      var closeBtn = window.pswp.element.querySelector('.pswp__button--close');
      if (closeBtn && !closeBtn.classList.contains('customized')) {
        closeBtn.innerHTML = `
          <svg fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 56 56">
            <circle cx="28" cy="28" r="28" fill="#fff"/>
            <circle cx="28" cy="28" r="27.5" stroke="#252627" stroke-opacity=".12"/>
            <path d="m22.344 22.343 11.313 11.314m-11.313 0 11.313-11.313" stroke="#252627" stroke-width="2"/>
          </svg>
        `;
        closeBtn.classList.add('customized');
      }
      // Do NOT clearInterval here!
    }
  }, 300);
});

// ============================== Custom code For JudgeMe reviews Control ===================================== //

// Applies to: full review widget AND preview badge in product info
// JDGM Rating Formatter: Force only 1 decimal, no rounding (e.g. 4.25 → 4.2, 5 → 5.0)
(function formatJudgeMeRatings() {

  function truncateTo1Decimal(value) {
    const num = parseFloat(value);
    if (Number.isInteger(num)) {
      return num.toFixed(1); // force .0 for integers like 5 => 5.0
    }
  
    const parts = num.toString().split(".");
    return `${parts[0]}.${parts[1][0] || '0'}`; // e.g. 4.25 => 4.2
  }

  function isValidNumber(text) {
    const value = parseFloat(text);
    return !isNaN(value);
  }

  function formatIfValid(el, label) {
    if (!el) return;

    const rawText = el.textContent.trim();
    if (!isValidNumber(rawText)) {
      return false;
    }

    const parsed = parseFloat(rawText);
    const formatted = truncateTo1Decimal(parsed);
    el.textContent = formatted;
    return true;
  }

  function waitForRatings() {
    const widgetRatingEl = document.querySelector(".jdgm-rev-widg__summary-average");
    const badgeRatingEl = document.querySelector(".jdgm-prev-badge__text");

    const widgetReady = formatIfValid(widgetRatingEl, "Widget Rating");
    const badgeReady = formatIfValid(badgeRatingEl, "Badge Rating");

    if (!widgetReady || !badgeReady) {
      setTimeout(waitForRatings, 800);
    }
  }

  setTimeout(waitForRatings, 800);
})();


// Replace contents of .jdgm-histogram__star with rating number + star icon
(function updateHistogramStars() {
  const container = document.getElementById("judgeme_product_reviews");
  if (!container) return setTimeout(updateHistogramStars, 300);

  const rows = container.querySelectorAll(".jdgm-histogram__row");
  if (!rows.length) return setTimeout(updateHistogramStars, 300);

  rows.forEach(row => {
    const rating = row.getAttribute("data-rating");
    const star = row.querySelector(".jdgm-histogram__star");
    if (rating && star) {
      // Clear any existing content
      star.innerHTML = '';

      // Create the rating number
      const numberNode = document.createTextNode(rating);

      // Create and insert the JDGM star span
      const starIcon = document.createElement("span");
      starIcon.classList.add("jdgm-star", "jdgm--on");
      starIcon.style.marginRight = "4px";
      starIcon.style.verticalAlign = "middle";

      // Append both
      star.appendChild(numberNode);
      star.appendChild(starIcon);
    }
  });
})();

// ================== Custom code To Trigger Tabby and Tamara Installment Pupop on Clicking on Installment Liquid Block  ================== //

// The Code To Trigger Tabby Popup
document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.getElementById('DYWANAH-showTabbyPopup');

  if (!trigger) return;

  trigger.addEventListener('click', () => {
    let attempts = 10;

    const tryClick = () => {
      const promo = document.querySelector('#TabbyPromo');
      if (!promo) return;

      const hosts = promo.querySelectorAll('span');
      for (const host of hosts) {
        const shadow = host.shadowRoot;
        const link = shadow?.querySelector('[data-test="widget-learn-more"]');
        if (link) {
          link.click();
          return true;
        }
      }
      return false;
    };

    if (tryClick()) return;

    const interval = setInterval(() => {
      if (tryClick() || --attempts <= 0) clearInterval(interval);
    }, 300);
  });
});

// The Code To Trigger Tamara Popup
document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.getElementById('DYWANAH-showTamaraPopup');

  if (!trigger) return;

  trigger.addEventListener('click', () => {
    let attempts = 10;

    const tryClick = () => {
      const widget = document.querySelector('tamara-widget');
      if (!widget) return false;

      const shadow = widget.shadowRoot;
      const link = shadow?.querySelector('.tamara-inline-learn-more-link');

      if (link) {
        link.click();
        return true;
      }

      return false;
    };

    if (tryClick()) return;

    const interval = setInterval(() => {
      if (tryClick() || --attempts <= 0) clearInterval(interval);
    }, 300);
  });
});

// ================== Custom code For Footer Accordion on Mobile ================== //
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth > 700) return;

  document.querySelectorAll('.DYWANAH-footer-accordion__header').forEach(function(header) {
    function toggleAccordion() {
      const content = header.nextElementSibling;
      const isOpen = header.classList.toggle('active');
      header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (content && content.classList.contains('DYWANAH-footer-accordion__content')) {
        content.classList.toggle('active', isOpen);
      }
    }

    header.addEventListener('click', toggleAccordion);
    header.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleAccordion();
      }
    });
  });
});


// =====================================================================================================================
// DYWANAH Custom Code For Collection Pages Filtering and Sorting                                               -  START
/**
 * ===================================================================
 *      FUTURE MAINTENANCE GUIDE FOR FILTERS & SORTING
 * ===================================================================
 * This guide explains how to add new filter and sort options.
 * The script is designed to be easily extendable.
 *
 * -------------------------------------------------------------------
 * I. ADDING A NEW SORTING OPTION (e.g., Alphabetical)
 * -------------------------------------------------------------------
 * 1. Add the new radio button to the Liquid file.
 * 2. No JavaScript changes are needed. The script handles `sort_by` automatically.
 * 3. IMPORTANT: The input's 'value' must be a standard Shopify sort key (e.g., "title-ascending").
 *    EXAMPLE: (<input type="radio" name="sort_by" value="title-ascending" ... />)
 *
 * -------------------------------------------------------------------
 * II. ADDING A NEW FILTER (Standard, Custom, or Metafield)
 * -------------------------------------------------------------------
 * Unlike sorting, adding ANY new filter requires manual JavaScript changes.
 * This ensures both the form submission and the count badges work correctly.
 *
 *   STEP 1: ADD THE HTML
 *   --------------------
 *   Add the filter's HTML input to `DYWANAH-collection__filter-sorting.liquid`.
 *   The `name` attribute MUST match Shopify's precise URL parameter format.
 *     - Product Option (e.g., Size): name="filter.p.option.size"
 *     - Product Tag: name="filter.p.tag"
 *     - Metafield: name="filter.p.metafield.custom.fabric_type"
 *
 *   STEP 2: UPDATE THE SUBMIT LOGIC (Handles Mobile)
 *   ------------------------------------------------
 *   Go to the `handleSubmit()` function in this file. You must add logic
 *   to read your new filter from the form and add it to the final URL.
 *   (Search for "ADD SUBMIT LOGIC FOR NEW FILTERS HERE" for the exact location.)
 *
 *   STEP 3: UPDATE THE SUBMIT LOGIC (Handles Desktop)
 *   ------------------------------------------------
 *   Go to the `handleDesktopImmediateUpdate()` function in this file. You must add logic
 *   to read your new filter from the form and add it to the final URL.
 *   (Search for "ADD IMMEDIATE LOGIC FOR NEW FILTERS HERE" for the exact location.)
 *
 *   STEP 4: UPDATE THE BADGE COUNTER LOGIC (Handles Mobile)
 *   -------------------------------------------------------
 *   Go to the `updateActiveFilterCount()` function. You must add a new
 *   `else if` rule to teach the function how to recognize your new
 *   filter's URL pattern and group it for an accurate count.
 *   (Search for "ADD COUNTING LOGIC FOR NEW FILTERS HERE" for the exact location.)
 *
 *   STEP 5: UPDATE THE ACCORDION HEADER DISPLAYED CHOOSED FILTERING OR SORTING OPTION
 *   ---------------------------------------------------------------------------------
 *   Add data-filter-group="..." to every .DYWANAH-filter-group div.
 *   For any future filter: use a unique, descriptive value (e.g., size, color, features, etc.)
 *   EXAMPLE: For Size: use data-filter-group="size"
 *
 * ===================================================================
 */
// ===================================================================================================================


class DYWANAHFilterAndSorting {
    constructor() {
      // Singleton pattern
      if (DYWANAHFilterAndSorting.instance) {
        return DYWANAHFilterAndSorting.instance;
      }
      DYWANAHFilterAndSorting.instance = this;
  
      // Only proceed if we're on a collection page
      if (!window.location.pathname.includes('/collections/')) {
        return;
      }
  
  
      // Debounce timer
      this.debounceTimer = null;
      this.defaultSort = 'created-descending';
  
      // Desktop price input debounce timer
      this.desktopPriceDebounceTimer = null;

      // Track desktop accordion state
      this.desktopAccordionState = new Map();
  
      // Set default sort if none is set
      this.setDefaultSort();
  
      // Set up all permanent click handlers using event delegation
      this.setupGlobalEventHandlers();
  
      // Set up desktop immediate update handlers
      this.setupDesktopEventHandlers();
  
      // Set the initial state of the filter count badge on page load
      this.updateActiveFilterCount();
  
      // Set initial desktop accordion state
      this.setDesktopAccordionState();

      // Sync form with URL on initial page load
      this.syncFormWithURL();
  
      // Listen for theme's AJAX updates
      document.addEventListener('theme:loading:end', () => {
        // We use a 0ms timeout to push our functions to the end of the event queue.
        // This ensures the DOM is fully updated and ready before our code runs.
        setTimeout(() => {
          this.syncFormWithURL();
          this.updateActiveFilterCount();
          this.setDesktopAccordionState();
        }, 0);
      });
    }
  
    // Helper: Detect if we're on desktop
    isDesktop() {
      return window.innerWidth >= 1000;
    }
  
    // Helper: Get the active form instance based on context
    getActiveInstance() {
      return this.isDesktop() 
        ? document.querySelector('.DYWANAH-desktop-instance')
        : document.querySelector('.DYWANAH-mobile-instance');
    }
  
    // Helper: Get the active form
    getActiveForm() {
      return this.getActiveInstance()?.querySelector('form');
    }
  
    // Set desktop accordion state (sorting open, filters closed)
    setDesktopAccordionState() {
      if (!this.isDesktop()) return;
    
      const desktopInstance = document.querySelector('.DYWANAH-desktop-instance');
      if (!desktopInstance) return;
    
      const allGroups = desktopInstance.querySelectorAll('.DYWANAH-filter-group');
      allGroups.forEach((group, index) => {
        const groupType = group.getAttribute('data-filter-group');
        
        // Check if we have saved state for this group
        const savedState = this.desktopAccordionState.get(groupType);
        
        if (savedState !== undefined) {
          // Restore saved state
          if (savedState) {
            group.classList.add('is-open');
          } else {
            group.classList.remove('is-open');
          }
        } else {
          // Default state: sorting open, others closed
          if (index === 0) {
            group.classList.add('is-open');
          } else {
            group.classList.remove('is-open');
          }
        }
      });
    }
    
    // Save current desktop accordion state before AJAX
    saveDesktopAccordionState() {
      if (!this.isDesktop()) return;
    
      const desktopInstance = document.querySelector('.DYWANAH-desktop-instance');
      if (!desktopInstance) return;
    
      const allGroups = desktopInstance.querySelectorAll('.DYWANAH-filter-group');
      allGroups.forEach((group) => {
        const groupType = group.getAttribute('data-filter-group');
        const isOpen = group.classList.contains('is-open');
        this.desktopAccordionState.set(groupType, isOpen);
      });
    }
  
    // Setup desktop immediate update event handlers
    setupDesktopEventHandlers() {
      if (!this.isDesktop()) return;
  
      // Handle desktop sorting (radio buttons) - immediate update
      document.body.addEventListener('change', (e) => {
        if (!this.isDesktop()) return;
        
        const desktopInstance = e.target.closest('.DYWANAH-desktop-instance');
        if (!desktopInstance) return;
  
        // Handle sorting radio buttons
        if (e.target.name === 'sort_by' && e.target.type === 'radio') {
          this.handleDesktopImmediateUpdate();
        }
  
        // Handle in stock checkbox
        if (e.target.name === 'in_stock' && e.target.type === 'checkbox') {
          this.handleDesktopImmediateUpdate();
        }
      });
  
      // Handle desktop price inputs - debounced update
      document.body.addEventListener('input', (e) => {
        if (!this.isDesktop()) return;
        
        const desktopInstance = e.target.closest('.DYWANAH-desktop-instance');
        if (!desktopInstance) return;
  
        // Handle price inputs with debouncing
        if ((e.target.name === 'price_min' || e.target.name === 'price_max') && e.target.type === 'tel') {
          this.handleDesktopPriceInputDebounced();
        }
      });
    }
  
    // Handle desktop immediate updates (for sorting and in stock)
    handleDesktopImmediateUpdate() {
      if (!this.isDesktop()) return;
  
      const form = this.getActiveForm();
      if (!form) return;
  
      const formData = new FormData(form);
      const searchParams = new URLSearchParams();
  
      const sortBy = formData.get('sort_by') || 'created-descending';
      searchParams.set('sort_by', sortBy);
  
      if (formData.get('in_stock')) {
        searchParams.set('filter.v.availability', '1');
      }
  
      const minPrice = this._convertArabicNumerals(formData.get('price_min'));
      const maxPrice = this._convertArabicNumerals(formData.get('price_max'));
      if (minPrice) searchParams.set('filter.v.price.gte', minPrice);
      if (maxPrice) searchParams.set('filter.v.price.lte', maxPrice);
  
      // --- ADD IMMEDIATE LOGIC FOR NEW FILTERS HERE ---
      // Example for a 'Size' filter (checkboxes):
      // const sizes = formData.getAll('filter.p.option.size');
      // sizes.forEach(size => searchParams.append('filter.p.option.size', size));
      // ---------------------------------------------
      
      // Save accordion state before AJAX update
      this.saveDesktopAccordionState();
      this.updateURLAndProducts(searchParams);
    }
  
    // Handle desktop price input changes with debouncing
    handleDesktopPriceInputDebounced() {
      if (!this.isDesktop()) return;
  
      clearTimeout(this.desktopPriceDebounceTimer);
      this.desktopPriceDebounceTimer = setTimeout(() => {
        this.handleDesktopImmediateUpdate();
      }, 600);
    }
  
    // Unified URL update and product refresh
    updateURLAndProducts(searchParams) {
      const url = new URL(window.location.href);
      url.search = searchParams.toString();
  
      const productList = document.querySelector('product-list');
      const sectionId = productList ? productList.id.replace('product-list-', '') : '';
      url.searchParams.set('section_id', sectionId);
  
      const cleanUrl = new URL(url.toString());
      cleanUrl.searchParams.delete('section_id');
      history.pushState({}, '', cleanUrl);
  
      document.dispatchEvent(new CustomEvent('facet:update', {
        bubbles: true,
        detail: { url: url }
      }));
  
      // Update active filter count after URL change
      setTimeout(() => {
        this.updateActiveFilterCount();
      }, 0);
    }
  
    /**
     * Converts Arabic/Indic numerals (٠-٩) in a string to Western Arabic numerals (0-9).
     * @param {string} str The string to convert.
     * @returns {string} The converted string.
     */
    _convertArabicNumerals(str) {
      if (typeof str !== 'string' || !str) {
        return str;
      }
      const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
      const englishNumerals = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      let newStr = str;
      for (let i = 0; i < 10; i++) {
        newStr = newStr.replace(new RegExp(arabicNumerals[i], 'g'), englishNumerals[i]);
      }
      return newStr;
    }
  
    setDefaultSort() {
      const params = new URLSearchParams(window.location.search);
      if (!params.has('sort_by')) {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', 'created-descending');
        
        const productList = document.querySelector('product-list');
        const sectionId = productList ? productList.id.replace('product-list-', '') : '';
        url.searchParams.set('section_id', sectionId);
  
        document.dispatchEvent(new CustomEvent('facet:update', {
          bubbles: true,
          detail: { url: url }
        }));
      }
    }
  
     // --- Scroll Handler ---
    setupScrollHandler() {
      const scrollable = document.querySelector('.DYWANAH-FilteringAndSorting-container__scrollable');
      const header = document.querySelector('.DYWANAH-FilteringAndSorting-container__header');
  
      if (!scrollable || !header) {
        return;
      }
      
      scrollable.addEventListener('scroll', function () {
        if (scrollable.scrollTop > 0) {
          header.classList.add('DYWANAH-FilteringAndSorting-container__scrolled');
        } else {
          header.classList.remove('DYWANAH-FilteringAndSorting-container__scrolled');
        }
      });
    }
  
    resetAccordionState() {
      const filterForm = this.getActiveForm();
      if (!filterForm) return;
  
      const allGroups = filterForm.querySelectorAll('.DYWANAH-filter-group');
      allGroups.forEach((group, index) => {
        if (index === 0) {
          // Always open the first group ("Sort By")
          group.classList.add('is-open');
        } else {
          // Ensure all other groups are closed
          group.classList.remove('is-open');
        }
      });
    }
  
    setupGlobalEventHandlers() {
      document.body.addEventListener('click', (e) => {
        // Handle drawer trigger button (mobile only)
        if (e.target.closest('#DYWANAH-filter-sort-trigger')) {
          e.preventDefault();
          this.openDrawer();
        }
  
        // Handle drawer close button (mobile only)
        if (e.target.closest('#DYWANAH-FilteringAndSorting-container-close')) {
          e.preventDefault();
          this.closeDrawer();
        }
  
        // Handle overlay click (mobile only)
        if (e.target.matches('#DYWANAH-FilteringAndSorting-container-overlay')) {
          e.preventDefault();
          this.closeDrawer();
        }
  
        // Handle "Clear All" button (both mobile and desktop)
        if (e.target.closest('#DYWANAH-FilteringAndSorting-container-clear')) {
          e.preventDefault();
          this.clearFilters();
        }
  
        // Handle accordion header clicks (both mobile and desktop)
        const accordionHeader = e.target.closest('.DYWANAH-filter-group__header');
        if (accordionHeader) {
          // Check if this click is from the active instance
          const clickedInstance = accordionHeader.closest('.DYWANAH-FilteringAndSorting-container');
          const activeInstance = this.getActiveInstance();
          
          if (clickedInstance === activeInstance) {
            const group = accordionHeader.parentElement;
            if (group) {
              group.classList.toggle('is-open');
            }
          }
        }
      });
  
      // Handle form submission (mobile only)
      document.body.addEventListener('submit', (e) => {
        if (e.target.matches('#DYWANAH-FilteringAndSorting-container-form')) {
          // Only handle form submission on mobile
          const mobileInstance = e.target.closest('.DYWANAH-mobile-instance');
          if (mobileInstance) {
            e.preventDefault();
            this.handleSubmit(e);
          }
        }
      });
  
      // Handle input changes for live product count (mobile only)
      document.body.addEventListener('input', (e) => {
        const mobileInstance = e.target.closest('.DYWANAH-mobile-instance');
        if (mobileInstance && e.target.name !== 'sort_by') {
          this.debouncedUpdateProductCount();
        }
      });
  
      // Handle browser back/forward buttons
      window.addEventListener('popstate', () => {
        if (document.querySelector('#DYWANAH-FilteringAndSorting-container')?.classList.contains('is-visible')) {
          this.closeDrawer();
        }
        this.updateProductsFromURL();
      });
    }
  
    openDrawer() {
      const drawer = document.querySelector('#DYWANAH-FilteringAndSorting-container');
      if (!drawer) return;
      
      
      drawer.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
  
      this.syncFormWithURL();
      this.resetAccordionState(); 
      this.updateProductCount();
      this.setupScrollHandler(); // <<< THE FIX IS MOVING THIS LINE HERE
    }
  
    closeDrawer() {
      const drawer = document.querySelector('#DYWANAH-FilteringAndSorting-container');
      if (!drawer) return;

      // Add closing class for blur effect
      document.body.classList.add('DYWANAH-FilteringAndSorting-container-closing');
      
      drawer.classList.remove('is-visible');
      document.body.style.overflow = '';

      // Remove closing class after blur animation completes (600 ms)
      setTimeout(() => {
        document.body.classList.remove('DYWANAH-FilteringAndSorting-container-closing');
      }, 600);
    }
  
    clearFilters() {
      const form = this.getActiveForm();
      if (!form) return;
  
      // Use the native form.reset() which is cleaner
      form.reset();
  
      // The form has radio buttons for sorting, not a select.
      // We need to find the default one and check it.
      const defaultSortRadio = form.querySelector('input[name="sort_by"][value="created-descending"]');
      if (defaultSortRadio) {
        defaultSortRadio.checked = true;
      }
  
      // Handle clear differently for mobile vs desktop
      if (this.isDesktop()) {
        // Desktop: Apply immediately
        this.handleDesktopImmediateUpdate();
      } else {
        // Mobile: Update product count
        this.updateProductCount();
      }
    }
  
    syncFormWithURL() {
      const form = this.getActiveForm();
      if (!form) return;
  
      const params = new URLSearchParams(window.location.search);
      
      const sortBy = params.get('sort_by') || 'created-descending';
      const sortRadio = form.querySelector(`input[name="sort_by"][value="${sortBy}"]`);
      if (sortRadio) sortRadio.checked = true;
  
      const inStock = params.get('filter.v.availability');
      const inStockCheckbox = form.querySelector('input[name="in_stock"]');
      if (inStockCheckbox) inStockCheckbox.checked = !!inStock;
  
      const minPrice = params.get('filter.v.price.gte');
      const minPriceInput = form.querySelector('input[name="price_min"]');
      if (minPriceInput) minPriceInput.value = minPrice || '';
  
      const maxPrice = params.get('filter.v.price.lte');
      const maxPriceInput = form.querySelector('input[name="price_max"]');
      if (maxPriceInput) maxPriceInput.value = maxPrice || '';
    }
  
    updateProductsFromURL() {
      const productList = document.querySelector('product-list');
      const sectionId = productList ? productList.id.replace('product-list-', '') : '';
      
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', sectionId);
  
      document.dispatchEvent(new CustomEvent('facet:update', {
        bubbles: true,
        detail: { url: url }
      }));
    }
  
    handleSubmit(event) {
      event.preventDefault();
      const form = this.getActiveForm();
      if (!form) return;
  
      const formData = new FormData(form);
      const searchParams = new URLSearchParams();
  
      const sortBy = formData.get('sort_by') || 'created-descending';
      searchParams.set('sort_by', sortBy);
  
      if (formData.get('in_stock')) {
        searchParams.set('filter.v.availability', '1');
      }
  
      const minPrice = this._convertArabicNumerals(formData.get('price_min'));
      const maxPrice = this._convertArabicNumerals(formData.get('price_max'));
      if (minPrice) searchParams.set('filter.v.price.gte', minPrice);
      if (maxPrice) searchParams.set('filter.v.price.lte', maxPrice);
  
      // --- ADD SUBMIT LOGIC FOR NEW FILTERS HERE ---
      // Example for a 'Size' filter (checkboxes):
      // const sizes = formData.getAll('filter.p.option.size');
      // sizes.forEach(size => searchParams.append('filter.p.option.size', size));
      // ---------------------------------------------
      
      this.updateURLAndProducts(searchParams);
  
      this.closeDrawer();
    }
  
    debouncedUpdateProductCount() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.updateProductCount();
      }, 300);
    }
  
    async updateProductCount() {
      const form = this.getActiveForm();
      if (!form) return;
      
      const applyButton = form.querySelector('.DYWANAH-FilteringAndSorting-container__apply');
      if (!applyButton) return;
      
      const countElement = applyButton.querySelector('.DYWANAH-FilteringAndSorting-container__apply-count');
      if (!countElement) return;
  
      try {
        const formData = new FormData(form);
        const searchParams = new URLSearchParams();
  
        if (formData.get('sort_by')) searchParams.set('sort_by', formData.get('sort_by'));
        if (formData.get('in_stock')) searchParams.set('filter.v.availability', '1');
        
        const minPrice = this._convertArabicNumerals(formData.get('price_min'));
        const maxPrice = this._convertArabicNumerals(formData.get('price_max'));
        if (minPrice) searchParams.set('filter.v.price.gte', minPrice);
        if (maxPrice) searchParams.set('filter.v.price.lte', maxPrice);
  
        const url = new URL(window.location.pathname, window.location.origin);
        url.search = searchParams.toString();
        
        const productList = document.querySelector('product-list');
        const sectionId = productList ? productList.id.replace('product-list-', '') : 'main-collection';
        url.searchParams.set('section_id', sectionId);
  
        const response = await fetch(url);
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        
        const resultsCountElement = html.querySelector('.collection-toolbar__products-count, .product-count');
        
        if (resultsCountElement) {
          const countText = resultsCountElement.textContent.trim();
          let finalCount = 0;
          const numbers = countText.match(/\d+/g);
          
          if (numbers && numbers.length > 0) {
            finalCount = parseInt(numbers[0]);
          } else if (countText === 'منتج واحد' || countText.toLowerCase().includes('one product') || countText.toLowerCase().includes('1 product')) {
            // Handle the specific Arabic text for "one product"
            finalCount = 1;
          }
          
          countElement.textContent = `(${finalCount})`;
        } else {
          countElement.textContent = '(0)';
        }
      } catch (error) {
        countElement.textContent = '';
      }
    }
  
    updateActiveFilterCount() {
      const badge = document.querySelector('.DYWANAH-filter-sort-trigger__badge');
      if (!badge) return;
  
      const params = new URLSearchParams(window.location.search);
      const filterGroups = new Set();
  
      for (const [key, value] of params.entries()) {
        if (key.startsWith('filter.')) {
          const parts = key.split('.');
          let group = null;
          if (parts[1] === 'v' && parts[2] === 'price') group = 'price';
          else if (parts[1] === 'v' && parts[2] === 'availability') group = 'availability';
          else if (parts[1] === 'p' && parts[2] === 'option') group = parts[3];
  
          // *** THIS IS THE NEW PART ***
          // Handle generic product tags
          //else if (parts[1] === 'p' && parts[2] === 'tag') {
          //   group = 'tag'; // Group all tags under a single "tag" filter type }
          // --- ADD COUNTING LOGIC FOR NEW FILTERS HERE ---
          // Example for a 'fabric_type' metafield filter:
          // else if (key.startsWith('filter.p.metafield.custom.fabric_type')) {
          //     group = 'fabric_type';
          // }
          // ---------------------------------------------
  
          if (group) filterGroups.add(group);
        }
      }
      
      const count = filterGroups.size;
  
      if (count > 0) {
        badge.textContent = count;
        badge.classList.add('DYWANAH-filter-sort-trigger__badge--visible');
      } else {
        badge.textContent = '';
        badge.classList.remove('DYWANAH-filter-sort-trigger__badge--visible');
      }
    }
  }
  
  // Initialize when DOM is ready
  if (window.location.pathname.includes('/collections/')) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => new DYWANAHFilterAndSorting());
    } else {
      new DYWANAHFilterAndSorting();
    }
  }
  
  
  // DYWANAHFilterChosenOptionManager: Handles showing chosen filter/sort options in accordion headers
  function DYWANAHFilterChosenOptionManager() {
    // Only run on collection pages
    if (!window.location.pathname.includes('/collections/')) return;
  
    // Helper: Get chosen value(s) for a filter group
    function getChosenValueForGroup(group) {
      const groupType = group.getAttribute('data-filter-group');
      const content = group.querySelector('.DYWANAH-filter-group__content');
      if (!content) return '';
  
      // 1. Sort By (radio)
      if (groupType === 'sort_by') {
        const checked = content.querySelector('input[type="radio"]:checked');
        if (checked) {
          const label = checked.closest('label');
          if (label) {
            return label.textContent.trim();
          }
          return checked.value;
        }
        return '';
      }
  
      // 2. In Stock (checkbox)
      if (groupType === 'in_stock') {
        const checkbox = content.querySelector('input[type="checkbox"]');
        if (checkbox && checkbox.checked) {
          return checkbox.nextSibling ? checkbox.nextSibling.textContent.trim() : '✓';
        }
        return '';
      }
  
      // 3. Price (range or min/max)
     if (groupType === 'price') {
        const min = content.querySelector('input[name="price_min"]');
        const max = content.querySelector('input[name="price_max"]');
        // Only show if user has typed something in min or max
        const minVal = min && min.value ? min.value : '';
        const maxVal = max && max.value ? max.value : '';
        if (minVal || maxVal) {
          // Use placeholder for max if user entered min but left max empty
          const displayMax = maxVal ? maxVal : (minVal && max && max.placeholder ? max.placeholder : '');
          return `${minVal ? minVal : '0'} - ${displayMax}`;
        }
        return '';
      }
  
      // 4. Generic: Checkboxes (multi-select, e.g., size, color, features)
      const checkedBoxes = content.querySelectorAll('input[type="checkbox"]:checked');
      if (checkedBoxes.length) {
        return Array.from(checkedBoxes).map(cb => {
          const label = cb.closest('label');
          if (label) {
            return label.textContent.trim();
          }
          return cb.value;
        }).join(', ');
      }
  
      // 5. Generic: Buttons with .active or .selected
      const selectedBtns = content.querySelectorAll('.active, .selected');
      if (selectedBtns.length) {
        return Array.from(selectedBtns).map(btn => btn.textContent.trim()).join(', ');
      }
  
      // 6. Add more cases as needed for future filter types
  
      return '';
    }
  
    // Update chosen option for a single group (only if collapsed)
    function updateChosenOptionForGroup(group) {
      const chosenSpan = group.querySelector('.DYWANAH-filter-group-choosed__option');
      if (!chosenSpan) return;
      // Only show if group is collapsed
      if (!group.classList.contains('is-open')) {
        const value = getChosenValueForGroup(group);
        chosenSpan.textContent = value;
        chosenSpan.style.display = value ? '' : 'none';
      } else {
        // Hide while open
        chosenSpan.textContent = '';
        chosenSpan.style.display = 'none';
      }
    }
  
    // Update all chosen option spans (for all collapsed groups)
    function updateAllChosenOptions() {
      document.querySelectorAll('.DYWANAH-filter-group').forEach(group => {
        updateChosenOptionForGroup(group);
      });
    }
  
    // Clear all chosen option spans
    function clearAllChosenOptions() {
      document.querySelectorAll('.DYWANAH-filter-group-choosed__option').forEach(span => {
        span.textContent = '';
        span.style.display = 'none';
      });
    }
  
    // Listen for drawer open (trigger button click)
    document.body.addEventListener('click', function(e) {
      if (e.target.closest('#DYWANAH-filter-sort-trigger')) {
        setTimeout(updateAllChosenOptions, 0); // Wait for drawer to open
      }
    });
  
    // Listen for accordion close (header click)
    document.body.addEventListener('click', function(e) {
      const header = e.target.closest('.DYWANAH-filter-group__header');
      if (header) {
        const group = header.closest('.DYWANAH-filter-group');
        // Wait for the class to update, then update the chosen option
        setTimeout(() => {
          updateChosenOptionForGroup(group);
        }, 150);
      }
    });
  
    // Listen for input changes (do NOT update while open)
    document.body.addEventListener('change', function(e) {
      const group = e.target.closest('.DYWANAH-filter-group');
      if (group && !group.classList.contains('is-open')) {
        updateChosenOptionForGroup(group);
      }
    });
  
    // Listen for "Clear All" button
    document.body.addEventListener('click', function(e) {
      if (e.target.closest('#DYWANAH-FilteringAndSorting-container-clear')) {
        clearAllChosenOptions();
      }
    });
  
    // Also update all when the drawer is opened via AJAX or other means
    document.addEventListener('theme:loading:end', function() {
      setTimeout(updateAllChosenOptions, 0);
    });
  
    // Initial run (in case drawer is open on page load)
    updateAllChosenOptions();
  }
  
  // Initialize the manager
  DYWANAHFilterChosenOptionManager();
  
  
  // Collection Page Layout Switch Code for cool Gymshark animation style
  
  document.addEventListener('DOMContentLoaded', () => {
    // Early return if not on collection page
    if (!window.location.pathname.includes('/collections/')) return;
  
    let observer = null;
  
    function updateLayoutSwitchState() {
      const container = document.querySelector('.collection-toolbar__layout-switch-list');
      const buttons = container?.querySelectorAll('.collection-toolbar__button');
      
      if (!container || !buttons.length) return;
  
      buttons.forEach(btn => {
        const svg = btn.querySelector('svg');
        const isActive = btn.classList.contains('is-active');
        
        if (svg) {
          svg.querySelectorAll('rect, path').forEach(el => {
            el.setAttribute('fill', isActive ? '#000' : '#ebe8e5');
          });
        }
  
        if (isActive && btn.hasAttribute('value')) {
          container.setAttribute('data-active', btn.getAttribute('value'));
        }
      });
    }
  
    function initializeLayoutSwitchAnimation() {
      const container = document.querySelector('.collection-toolbar__layout-switch-list');
      const buttons = container?.querySelectorAll('.collection-toolbar__button');
      
      if (!container || !buttons.length) return;
  
      // Disconnect existing observer
      if (observer) {
        observer.disconnect();
      }
  
      // Run initial state update
      updateLayoutSwitchState();
  
      // Create new observer
      observer = new MutationObserver(updateLayoutSwitchState);
      
      // Observe the container for changes
      observer.observe(container, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class']
      });
  
      // Also observe each button for class changes
      buttons.forEach(button => {
        observer.observe(button, {
          attributes: true,
          attributeFilter: ['class']
        });
      });
    }
  
    // Initialize on page load
    initializeLayoutSwitchAnimation();
  
    // Reinitialize after AJAX updates (same pattern as DYWANAH filter)
    document.addEventListener('theme:loading:end', () => {
      // Use setTimeout to ensure DOM is fully updated (same as filter code)
      setTimeout(() => {
        initializeLayoutSwitchAnimation();
      }, 0);
    });
  });

// ====================================================================================
// DYWANAH Custom Code For Collection Pages Filtering and Sorting  - END
// ====================================================================================




// ================== Custom code For Footer VAT Popup Control ================== //

  function openVatPopup() {
    document.getElementById('vat-popup').classList.add('active');
    document.getElementById('vat-popup-overlay').classList.add('active');
    document.body.classList.add('vat-modal-open');
  }

  function closeVatPopup() {
    document.getElementById('vat-popup').classList.remove('active');
    document.getElementById('vat-popup-overlay').classList.remove('active');
    document.body.classList.remove('vat-modal-open');
  }

